import { render, staticRenderFns } from "./2.vue?vue&type=template&id=7b93516e&scoped=true"
import script from "./2.vue?vue&type=script&lang=js"
export * from "./2.vue?vue&type=script&lang=js"
import style0 from "./2.vue?vue&type=style&index=0&id=7b93516e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b93516e",
  null
  
)

export default component.exports